module.exports = __webpack_public_path__ + "static/media/github.0918d786.png";